import AppHeader from 'components/AppHeader';
import { Form } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import accountApis from 'api/accountApis';
import { AppRoutes } from '../../configs/AppRoutes';
import AccountForm from './components/form';
import { useLocation } from 'react-router-dom';

export default function NewAccountPage() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const fromSource = location.state?.from_source;
  console.log('fromSource', fromSource);
  const handleOnSubmit = async () => {
    setIsLoading(true);
    try {
      const data = form.getFieldsValue();
      const res = await accountApis.create(data);
      if (res.code === 200) {
        if (fromSource === 'ai_store') {
          navigate(AppRoutes.Accounts.ListAiStore.path);
        } else { 
          navigate(AppRoutes.Accounts.ListAiHub.path);
        }
        message.success('Account created successfully');
      } else {
        message.error(res.message || 'Failed to create account');
      }
    } catch (error) {
      message.error(error.message || 'An error occurred while creating the account');
    }
    setIsLoading(false);
  };

  const submitForm = () => {
    form
      .validateFields()
      .then(() => {
        handleOnSubmit();
      })
      .catch((info) => {
        const errorMsg = 'Validation Failed: ' + info.errorFields[0].errors[0];
        form.scrollToField(info.errorFields[0].name, {
          behavior: 'smooth',
          block: 'center'
        });
        message.error(errorMsg);
      });
  };

  return (
    <>
      <AppHeader
        fixedTop
        pageTitle="Create New Account"
        pageHeaderExtras={[
          <Button type="primary" onClick={submitForm} loading={isLoading}>
            Create
          </Button>
        ]}
      />
      <AccountForm
        form={form}
        fromSource={fromSource}
      />
    </>
  );
}
